import i18n from '@/Plugins/i18n.js';

export default function translateNightCrawlerCode(check) {
  const key = `common.dns_errors.${check.msg_code}`;

  // Check if translation exists
  if (i18n.global.te(key)) {
    return i18n.global.t(key);
  }

  // Fall back to original message
  return check.msg;
}
